// extracted by mini-css-extract-plugin
export default {"bell":"Notifications-module__bell___eplqo","unseenCountDot":"Notifications-module__unseenCountDot___qWyNy"};